import React, {useEffect, useLayoutEffect, useRef, useState} from 'react'

import HintPopover from "../../../../../../src/core/gd-ui/hint-popover/hint-popover"

//@ts-ignore
import InlineInput from '../../../../../core/gd-components/inline-edit/input/input'

type Props = {
    className?      : string
    style?          : any

    name            : string

    maxWidth?       : number

    withPadding?    : boolean
    noLeftPadding?  : boolean
    editable?       : boolean

    onChange?       : func
}

export default function HeaderAppTitleNew(props:Props) {

    const selfRef   :any = useRef()
    const inputRef  :any = useRef()

    const [isEditing, setIsEditing] = useState(false)
    const [useHint, setUseHint]     = useState(false)
    const [name, setName]           = useState(props.name)

    useEffect(() => {
        setName(props.name)
    }, [props.name])

    useLayoutEffect(() => {
        const newUseHint = gd.utils.getTextExceedsNodeWidth(name, selfRef.current, 10, 16, null, {fontWeight: 700})
        if (useHint !== newUseHint) setUseHint(newUseHint)
    }, [name])

    useLayoutEffect(() => {
        if (isEditing) {
            inputRef.current.focus()
        }
    }, [isEditing])

    // const handleClickOutside = () => {setIsEditing(false)}

    const onEditClick = () => {
        if (!props.editable) return;

        setIsEditing(true)
    }

    const onBlur = () => {
        const newValue = inputRef.current.state.value

        if (newValue.trim() === '') return

        setName(newValue)
        setIsEditing(false)

        if (props.onChange && name !== newValue) props.onChange(newValue)
    }

    const classes = Classes("ui5-title-app-name", props.className, {
        'with-padding'                  : props.withPadding,
        'no-left-padding'               : props.withPadding && props.noLeftPadding,
        ['max-w-{0}'.f(props.maxWidth)] : !!props.maxWidth,
        editable                        : props.editable && !isEditing,
        'is-editing'                    : isEditing
    })

    if (isEditing)
        return (
            <div ref={selfRef} className={classes}>
                <InlineInput ref        = {inputRef}
                             className  = "gd-input big"
                             style      = {props.style}
                             value      = {name}
                             onBlur     = {onBlur}/>
            </div>
        )
    else
        return (
            <div ref={selfRef} className={classes} style={props.style} onClick={onEditClick}>
                {name}
                {useHint && <HintPopover hint={name} multiline={true} showDelay={500}/>}
            </div>
        )
}

HeaderAppTitleNew.defaultProps = {
    maxWidth    : 350,
    withPadding : true
}
